module.exports = __webpack_public_path__ + "img/KR.264b12ce.svg";